export default "__VITE_ASSET__sI43aPIl__"